// extracted by css-extract-rspack-plugin
export default {"Tab":"Tab-NCnXYR","tab":"Tab-NCnXYR","is-active":"is-active-SRgu3U","isActive":"is-active-SRgu3U"};